// src/components/Schedule.js (NUOVO)

import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton,
  Box, Typography, Stack, Grid, TextField, Switch, FormControlLabel,
  ToggleButtonGroup, ToggleButton, InputAdornment, FormHelperText
} from '@mui/material';
import {
  Close as CloseIcon, Event as EventIcon, AccessTime as AccessTimeIcon,
  Timer as TimerIcon
} from '@mui/icons-material';
import { LocalizationProvider, DatePicker, TimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { it } from 'date-fns/locale';
import { format as formatDate } from 'date-fns';

const daysOfWeek = [
  { key: 'Lun', value: '1' },
  { key: 'Mar', value: '2' },
  { key: 'Mer', value: '3' },
  { key: 'Gio', value: '4' },
  { key: 'Ven', value: '5' },
  { key: 'Sab', value: '6' },
  { key: 'Dom', value: '0' },
];

export default function Schedule({ open, onClose, onSave, selectedCount, selectedItems = [] }) {


  useEffect(() => {
    if (selectedCount > 0 && selectedItems[0] === undefined) {
      console.error("Errore: selectedItems non definito correttamente nonostante selectedCount > 0");
      return;
    }
    switch (selectedCount) {
      case 0:
        // Nessun elemento selezionato, resetta i campi
        setScheduleData({
          play_date_start: new Date(),
          play_date_end: null,
          play_time_start: null,
          play_time_end: null,
          play_days: ['1', '2', '3', '4', '5', '6', '0'], // Default a tutti i giorni
          player_time: '',
        });
        setIsAllDay(true);
        break;
      case 1:
        // Un solo elemento selezionato, carica i dati esistenti
        const item = selectedItems[0];        
        if (!item.play_date_start && !item.play_date_end && !item.play_time_start && !item.play_time_end && !item.play_days) {
          console.log("Nessuna programmazione esistente per l'elemento selezionato.");
          console.log(item);
        }
        setScheduleData({
          play_date_start: item.play_date_start ? new Date(item.play_date_start) : null,
          play_date_end: item.play_date_end ? new Date(item.play_date_end) : null,
          play_time_start: item.play_time_start ? new Date(`1970-01-01T${item.play_time_start}`) : null,
          play_time_end: item.play_time_end ? new Date(`1970-01-01T${item.play_time_end}`) : null,
          play_days: item.play_days ? item.play_days.split('').map((val, idx) => val === '1' ? daysOfWeek[idx].value : null).filter(Boolean) : ['1', '2', '3', '4', '5', '6', '0'],
          player_time: item.player_time || '',
        });
        // Determina se è "Tutto il giorno"
        if (item.play_time_start === '00:00:00' && item.play_time_end === '23:59:59') {
          setIsAllDay(true);
        } else {
          setIsAllDay(false);
        }
        break;
      default:
        // Trova le intersezioni tra gli elementi selezionati
        const intersectDates = (field, bound) => {
          const dates = selectedItems.map(item => item[field] ? new Date(item[field]) : null).filter(Boolean);
          // Oggi se lb oppure tra una settimana se ub
          if (dates.length === 0) return bound === "lb" ? new Date() : new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
          const firstDate = dates[0];
          return dates.every(date => date.getTime() === firstDate.getTime()) ? firstDate : (bound === "lb" ? new Date() : new Date(Date.now() + 7 * 24 * 60 * 60 * 1000))
        };
        const intersectTimes = (field) => {
          const times = selectedItems.map(item => item[field] ? new Date(`1970-01-01T${item[field]}`) : null).filter(Boolean);
          if (times.length === 0) return null;
          const firstTime = times[0];
          return times.every(time => time.getTime() === firstTime.getTime()) ? firstTime : null;
        };
        const intersectDays = () => {
          const allDays = selectedItems.map(item => item.play_days ? item.play_days.split('').map((val, idx) => val === '1' ? daysOfWeek[idx].value : null).filter(Boolean) : []);
          if (allDays.length === 0) return ['1', '2', '3', '4', '5', '6', '0'];
          return daysOfWeek.map(day => allDays.every(days => days.includes(day.value)) ? day.value : null).filter(Boolean);
        };
        setScheduleData({
          play_date_start: intersectDates('play_date_start', 'lb'),
          play_date_end: intersectDates('play_date_end', 'ub'),
          play_time_start: intersectTimes('play_time_start'),
          play_time_end: intersectTimes('play_time_end'),
          play_days: intersectDays(),
          player_time: '', // Non si può determinare un valore comune
        });
        // Determina se è "Tutto il giorno"
        const allDay = selectedItems.every(item => item.play_time_start === '00:00:00' && item.play_time_end === '23:59:59');
        setIsAllDay(allDay);
        break;
    }
  }, [selectedCount, selectedItems]);
    
  const [scheduleData, setScheduleData] = useState({
    play_date_start: null,
    play_date_end: null,
    play_time_start: null,
    play_time_end: null,
    play_days: ['1', '2', '3', '4', '5', '6', '0'], // Default a tutti i giorni
    player_time: '',
  });
  const [isAllDay, setIsAllDay] = useState(true);

  const handleValueChange = (field, value) => {
    setScheduleData(prev => ({ ...prev, [field]: value }));
  };

  const handleDaysChange = (event, newDays) => {
    handleValueChange('play_days', newDays);
  };
  
  const toggleAllDay = (event) => {
    const checked = event.target.checked;
    setIsAllDay(checked);
    if (checked) {
      // Imposta orari di default per tutto il giorno
      setScheduleData(prev => ({
        ...prev,
        play_time_start: new Date(0, 0, 0, 0, 0, 0),
        play_time_end: new Date(0, 0, 0, 23, 59, 59),
      }));
    } else {
      // Pulisci gli orari
      setScheduleData(prev => ({ ...prev, play_time_start: null, play_time_end: null }));
    }
  };

  const handleSave = async () => {
    // Formatta i dati prima di inviarli al genitore
    const formattedData = {
      play_date_start: scheduleData.play_date_start ? formatDate(scheduleData.play_date_start, 'yyyy-MM-dd') : undefined,
      play_date_end: scheduleData.play_date_end ? formatDate(scheduleData.play_date_end, 'yyyy-MM-dd') : undefined,
      play_time_start: scheduleData.play_time_start ? formatDate(scheduleData.play_time_start, 'HH:mm:ss') : undefined,
      play_time_end: scheduleData.play_time_end ? formatDate(scheduleData.play_time_end, 'HH:mm:ss') : undefined,
      player_time: scheduleData.player_time || undefined,
      // Converte l'array dei giorni in una stringa di 7 caratteri (es. '1111100')
      play_days: daysOfWeek.map(day => scheduleData.play_days.includes(day.value) ? '1' : '0').join(''),
    };
    
    // Rimuove le proprietà non definite per non sovrascrivere i dati esistenti con null
    Object.keys(formattedData).forEach(key => formattedData[key] === undefined && delete formattedData[key]);
    
    await onSave(formattedData);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        Programma {selectedCount} {selectedCount === 1 ? 'Elemento' : 'Elementi'}
        <IconButton onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}><CloseIcon /></IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={it}>
          <Grid container spacing={3} sx={{ p: 1 }}>
            
            {/* --- SEZIONE DATE --- */}
            <Grid item xs={12}>
              <Typography variant="overline" color="text.secondary">Periodo di Validità</Typography>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mt: 1 }}>
                <DatePicker
                  label="Inizia il"
                  value={scheduleData.play_date_start}
                  onChange={(newValue) => handleValueChange('play_date_start', newValue)}
                  slotProps={{ textField: { fullWidth: true, InputProps: { startAdornment: (<InputAdornment position="start"><EventIcon /></InputAdornment>) } } }}
                />
                <DatePicker
                  label="Termina il"
                  value={scheduleData.play_date_end}
                  onChange={(newValue) => handleValueChange('play_date_end', newValue)}
                  slotProps={{ textField: { fullWidth: true, InputProps: { startAdornment: (<InputAdornment position="start"><EventIcon /></InputAdornment>) } } }}
                />
              </Stack>
            </Grid>

            {/* --- SEZIONE ORARI --- */}
            <Grid item xs={12}>
              <Typography variant="overline" color="text.secondary">Fascia Oraria</Typography>
              <FormControlLabel control={<Switch checked={isAllDay} onChange={toggleAllDay} />} label="Tutto il giorno" sx={{ display: 'block', mb: 1 }}/>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <TimePicker
                  label="Dalle ore"
                  disabled={isAllDay}
                  value={scheduleData.play_time_start}
                  onChange={(newValue) => handleValueChange('play_time_start', newValue)}
                  slotProps={{ textField: { fullWidth: true, InputProps: { startAdornment: (<InputAdornment position="start"><AccessTimeIcon /></InputAdornment>) } } }}
                />
                <TimePicker
                  label="Alle ore"
                  disabled={isAllDay}
                  value={scheduleData.play_time_end}
                  onChange={(newValue) => handleValueChange('play_time_end', newValue)}
                  slotProps={{ textField: { fullWidth: true, InputProps: { startAdornment: (<InputAdornment position="start"><AccessTimeIcon /></InputAdornment>) } } }}
                />
              </Stack>
            </Grid>

            {/* --- SEZIONE GIORNI DELLA SETTIMANA --- */}
            <Grid item xs={12}>
              <Typography variant="overline" color="text.secondary">Giorni di Riproduzione</Typography>
              <ToggleButtonGroup value={scheduleData.play_days} onChange={handleDaysChange} fullWidth sx={{ mt: 1 }}>
                {daysOfWeek.map(day => (
                  <ToggleButton color={scheduleData.play_days.includes(day.value) ? 'primary' : 'default'} selected={scheduleData.play_days.includes(day.value)} key={day.key} value={day.value} >{day.key}</ToggleButton>
                ))}
              </ToggleButtonGroup>
            </Grid>
            
            {/* --- SEZIONE DURATA --- */}
            {/* <Grid item xs={12} sm={6}>
              <Typography variant="overline" color="text.secondary">Durata di Visualizzazione</Typography>
              <TextField
                label="Durata"
                type="number"
                value={scheduleData.player_time}
                onChange={(e) => handleValueChange('player_time', e.target.value)}
                fullWidth
                sx={{ mt: 1 }}
                InputProps={{
                  startAdornment: <InputAdornment position="start"><TimerIcon /></InputAdornment>,
                  endAdornment: <InputAdornment position="end">secondi</InputAdornment>
                }}
              />
              <FormHelperText>Solo per le immagini. Lasciare vuoto per non modificare.</FormHelperText>
            </Grid> */}

          </Grid>
        </LocalizationProvider>
      </DialogContent>
      <DialogActions sx={{ p: '16px 24px' }}>
        <Button onClick={onClose}>Annulla</Button>
        <Button variant="contained" onClick={() => handleSave().then(() => onClose())}>Salva Programmazione</Button>
      </DialogActions>
    </Dialog>
  );
}